import React, { Fragment, Component } from "react";
import { connetParams } from "../../utils/Connect";
import { getCookie, eraseCookie } from '../../utils/Cookies';
import { Link, useNavigate } from "react-router-dom";

class Element extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tools: Array(),
            loading: true
        }
    }
    componentDidMount() {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + getCookie('token'));
        const params = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        connetParams(
            'tools',
            params
        ).then(response => response.text())
            .then(result => {
                const data = JSON.parse(result);
                if (data['detail'] === 'Invalid credentials') {
                    eraseCookie('token');
                    this.props.navigate('/');
                }
                this.setState({
                    tools: data.tools,
                    loading: false
                })
            })
            .catch(error => {
                console.log(error.message);
            });
    }
    deleteTool = (id) => {
        if (window.confirm('Estas seguro que quieres eliminar esta herramienta?')) {
            let myHeaders = new Headers();
            myHeaders.append("Authorization", "Bearer " + getCookie('token'));
            const params = {
                method: 'DELETE',
                headers: myHeaders,
                redirect: 'follow'
            };
            connetParams(
                'tool/' + id,
                params
            ).then(response => response.text())
                .then(result => {
                    const data = JSON.parse(result);
                    if (data['detail'] === 'Invalid credentials') {
                        eraseCookie('token');
                        this.props.navigate('/');
                    }
                    this.componentDidMount();
                })
                .catch(error => {
                    this.componentDidMount();
                    console.log(error.message);
                    console.error('There was a problem with the fetch operation:', error.message);
                });
        } else {
            // Do nothing!
            console.log('cancel.');
        }
    }
    render() {
        const { tools, loading } = this.state;
        return (
            <Fragment>
                <main>
                    <div className="container-fluid px-4">
                        <h1 className="mt-4">Herramientas</h1>
                        <ol className="breadcrumb mb-4">
                            <li className="breadcrumb-item"><Link to={"/"}>Dashboard</Link></li>
                            <li className="breadcrumb-item active">Herramientas</li>
                        </ol>
                        <div className="card mb-4">
                            <div className="card-header">
                                <i className="fas fa-table me-1"></i>
                                Lista de herramientas
                            </div>
                            <div className="card-body">
                                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <Link
                                        to={'/tool/create'}
                                        className="btn btn-primary me-md-2"
                                    >
                                        crear herramienta
                                    </Link>
                                </div>
                                {
                                    loading ? (
                                        <div className="d-grid gap-2 col-12 mx-auto">
                                            <div className="d-flex justify-content-center">
                                                <div className="spinner-grow text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Id</th>
                                                    <th scope="col">Nombre</th>
                                                    <th scope="col">modelo</th>
                                                    <th scope="col">Cliente</th>
                                                    <th scope="col"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    tools.map(tool => {
                                                        return (
                                                            <tr>
                                                                <td>{tool._id}</td>
                                                                <td>{tool.name}</td>
                                                                <td>{tool.model}</td>
                                                                <td>{tool.customer_id}</td>
                                                                <td>
                                                                    {/* <Link
                                                                        to={'/super_assistant/' + assistant._id}
                                                                    >
                                                                        <i className="fa-solid fa-eye m-1"></i>
                                                                    </Link> */}
                                                                    <Link
                                                                        to={'/tool/edit/' + tool._id}
                                                                    >
                                                                        <i className="fa-solid fa-pen-to-square m-1"></i>
                                                                    </Link>
                                                                    <a className="link-danger" type="submit" onClick={() => this.deleteTool(tool._id)}><i className="fa-solid fa-trash m-1"></i></a >
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </main>
            </Fragment>
        )
    }
}

function Tools() {
    let navigate = useNavigate();
    return <Element navigate={navigate} />
}

export default Tools;